import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class LoanDetailsTableLoanNumber extends Component<{ loanNumber: string }> {
    render() {
        return <OptionalTableCell title='Loan Number'>
            {this.props.loanNumber}
        </OptionalTableCell>;
    }
}